var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 12.5V15.1667",
    stroke: "#EAAC35",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66628 25.8333H25.3329C26.2163 25.8271 27.0393 25.3839 27.5306 24.6496C28.0218 23.9154 28.1176 22.9856 27.7863 22.1667L18.3196 5.83333C17.85 4.98449 16.9564 4.45766 15.9863 4.45766C15.0162 4.45766 14.1226 4.98449 13.6529 5.83333L4.18628 22.1667C3.86147 22.9663 3.94377 23.8737 4.40715 24.6019C4.87052 25.33 5.65766 25.7889 6.51961 25.8333",
    stroke: "#EAAC35",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 19.8333H16.0132",
    stroke: "#EAAC35",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.40cf7a2a1546fa9432704005ebc71c78.svg";
export { ForwardRef as ReactComponent };